import Cookies from 'js-cookie';
import { isABTestActive, isCYOMode } from './params';

export const EXTENDED_SEGMENTATION_COOKIE = 'extendedSegmentationTest';

export const initialShowExtendedSegmentation = (isShowing = true) => {
  const hasCookie = Boolean(Cookies.get(EXTENDED_SEGMENTATION_COOKIE));
  return (
    isABTestActive('2024-06_extended_segmentation_test_active') &&
    !hasCookie &&
    isCYOMode() &&
    isShowing
  );
};
